import { useQuery } from "@tanstack/react-query";
import { GlobeResponseSchema, type GlobeResponse } from "#shared/schemas/globe.ts";
import { api } from "@web/lib/api.ts";

export function useGlobeData() {
  return useQuery({
    queryKey: ["globe"],
    queryFn: async (): Promise<GlobeResponse> => {
      return GlobeResponseSchema.parse(await api("/api/globe"));
    },
    staleTime: 60_000,
  });
}
